import React from 'react';
import { Tab, TabController, Tabs } from '@one-thd/sui-atomic-components';
import { string, func, number } from 'prop-types';
import QuotesTabPanels from './QuotesTabPanels';
import { quotesPropType } from '../../utils/propTypes';

const QuotesTabsView = ({
  activeQuotes,
  containerWidth,
  expiredQuotes,
  maxListSize,
  selectedTab,
  setSelectedTab,
}) => (
  <TabController value={selectedTab}>
    <Tabs
      value={selectedTab}
      onChange={(_event, newValue) => setSelectedTab(newValue)}
      aria-label="Quotes status tabs"
      variant={containerWidth <= 385 ? 'fullWidth' : 'standard'}
    >
      <Tab label={`Active (${activeQuotes.length})`} value="active" />
      <Tab label={`Expired (${expiredQuotes.length})`} value="expired" />
    </Tabs>
    <QuotesTabPanels
      activeQuotes={activeQuotes}
      expiredQuotes={expiredQuotes}
      maxListSize={maxListSize}
    />
  </TabController>
);

QuotesTabsView.propTypes = {
  selectedTab: string.isRequired,
  setSelectedTab: func.isRequired,
  containerWidth: number,
  activeQuotes: quotesPropType.isRequired,
  expiredQuotes: quotesPropType.isRequired,
  maxListSize: number,
};
QuotesTabsView.defaultProps = {
  containerWidth: undefined,
  maxListSize: 3
};
export default QuotesTabsView;